export default "__VITE_ASSET__Bhpol1Jq__"